export enum Industry {
  Technology = "Technology",
  Healthcare = "Healthcare",
  Finance = "Finance",
  Education = "Education",
  Retail = "Retail",
  Manufacturing = "Manufacturing",
  Consulting = "Consulting",
  Other = "Other",
}
